var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 6.5C4.00001 5.09987 4.00001 4.3998 4.28028 3.86502C4.52681 3.39462 4.92019 3.01217 5.40403 2.77248C5.95409 2.5 6.67416 2.5 8.1143 2.5H11.8857C13.3259 2.5 14.0459 2.5 14.596 2.77248C15.0798 3.01217 15.4732 3.39462 15.7197 3.86502C16 4.3998 16 5.09987 16 6.5V13.4212C16 14.7631 16 15.434 15.7179 15.8264C15.4717 16.1687 15.0928 16.3917 14.674 16.4406C14.194 16.4967 13.6075 16.1708 12.4345 15.5191L10 14.1667L7.56555 15.5191C6.39253 16.1708 5.80601 16.4967 5.326 16.4406C4.90718 16.3917 4.52829 16.1687 4.28214 15.8264C4.00001 15.434 4.00001 14.7631 4.00001 13.4212V6.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.71970305e43b6dfca55b2b74cfb45208.svg";
export { ForwardRef as ReactComponent };